import React from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate } from 'react-router-dom'
import { useEvent } from 'context/EventContext'
import { IconBack } from 'shared/components/icons'

function TopBar({ title, backTo, hideBack }) {
  const navigate = useNavigate()
  const location = useLocation()
  const { event } = useEvent()
  const resolvedTitle = title || event?.sTitle || 'Gate Scanner'
  const isEventHome = /\/events\/[^/]+$/.test(location.pathname)

  return (
    <header className="sticky top-0 z-30 flex min-h-[64px] items-center gap-2 border-b border-line bg-surface/95 px-3 backdrop-blur">
      {!hideBack && (
        <button
          type="button"
          className="flex h-12 w-12 items-center justify-center rounded-2xl bg-elevated"
          onClick={() => (backTo ? navigate(backTo) : isEventHome ? navigate('/') : navigate(-1))}
          aria-label="Back"
        >
          <IconBack className="h-5 w-5" />
        </button>
      )}
      <h1 className="mb-0 min-w-0 flex-1 truncate text-xl font-bold">{resolvedTitle}</h1>
    </header>
  )
}

TopBar.propTypes = {
  title: PropTypes.string,
  backTo: PropTypes.string,
  hideBack: PropTypes.bool
}

export default TopBar
